import styled from '@emotion/styled'
import PropTypes from 'prop-types'

import {
  BUTTON_SIZES,
  BUTTON_VARIANTS,
  buttonBase,
  fillsMobileWidth,
  mobileFullWidth,
  sizeStyles,
  variantStyles,
} from './buttonStyles'

/** A single-line button with configurable size and appearance. */
const Button = styled.button`
  ${buttonBase};
  max-width: 100%;

  ${sizeStyles};
  ${variantStyles};

  ${p => fillsMobileWidth(p) && mobileFullWidth}
`

Button.propTypes = {
  /** Controls fill, border, text color, and interaction states. */
  variant: PropTypes.oneOf(BUTTON_VARIANTS),

  /** Controls height and font size. */
  size: PropTypes.oneOf(BUTTON_SIZES),

  /** Sets an explicit width and removes horizontal padding. */
  width: PropTypes.string,

  children: PropTypes.node,
}

// Presets for styled subclasses; use `Button` directly at call sites.
export const PrimaryButton = props => <Button {...props} variant='primary' />
export const SecondaryButton = props => <Button {...props} variant='secondary' />
export const TertiaryButton = props => <Button {...props} variant='tertiary' />

export const SmallPrimaryButton = props => <Button {...props} variant='primary' size='small' />
export const SmallSecondaryButton = props => <Button {...props} variant='secondary' size='small' />
export const SmallTertiaryButton = props => <Button {...props} variant='tertiary' size='small' />
export const XSmallPrimaryButton = props => <Button {...props} variant='primary' size='xsmall' />
export const XSmallSecondaryButton = props => (
  <Button {...props} variant='secondary' size='xsmall' />
)
export const XSmallTertiaryButton = props => <Button {...props} variant='tertiary' size='xsmall' />

export default Button
